/**
 * @file permissions.js
 * @description Utilitários de permissões (CRA)
 */

/**
 * Verifica se o usuário é administrador
 * @param {Array} permissions - Array de permissões do usuário
 * @returns {boolean} True se o usuário é admin
 */
export function isAdmin(permissions) {
  if (!permissions || permissions.length === 0) {
    return false
  }

  const adminRoles = ["admin", "administrador", "administrator"]
  return permissions.some(
    (role) => adminRoles.includes(role.name?.toLowerCase() || "")
  )
}

/**
 * Verifica se o usuário tem uma permissão específica
 * @param {Array} permissions - Array de permissões do usuário
 * @param {string} permissionName - Nome da permissão
 * @param {'islist' | 'isinsert' | 'isremove'} [action] - Ação específica
 * @returns {boolean} True se o usuário tem a permissão
 */
export function hasPermission(
  permissions,
  permissionName,
  action
) {
  if (!permissions || permissions.length === 0) return false

  const role = permissions.find((role) => role.name === permissionName)

  if (!role) {
    return false
  }

  if (!action) {
    return true
  }

  const actionValue = role[action]

  if (actionValue === true) {
    return true
  }

  if (actionValue === null && action === "islist" && role.isinsert === true) {
    return true
  }

  if (actionValue === null) {
    return false
  }

  return false
}

/**
 * Obtém as permissões do localStorage
 * @returns {Array} Array de permissões
 */
export function getPermissionsFromStorage() {
  try {
    const storagedUser = localStorage.getItem("user_token")
    if (storagedUser) {
      const user = JSON.parse(storagedUser)
      return user.roles || []
    }
  } catch (error) {
    console.error("Erro ao carregar permissões do localStorage:", error)
  }
  return []
}
